import { RouteAnimationShared } from './../../../utils/route-animation-shared';
import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { interval, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { UserApiService } from 'src/app/data/repository/user-repository/user-api.service';
import { TextHelper } from 'src/app/utils/text-helper';
import { phoneNumberUrl, registerUrl, mainUrl } from 'src/app/global-variables';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { AuthenticationAnalyticsService } from 'src/app/data/repository/analytics-repository/authentication-analytics.service';
import { WebengageService } from 'src/app/data/repository/analytics-repository/webengage.service';

@Component({
  selector: 'app-activation-code',
  templateUrl: './activation-code.component.html',
  styleUrls: ['./activation-code.component.scss'],
})
export class ActivationCodeComponent implements OnInit, OnDestroy {
  hasError = false;
  errorMessage: string;
  buttonTitle = 'تایید شماره';
  counter = 60;
  phoneNumber = '';
  activationCode: string;
  isFocuse: boolean = false;
  returnUrl: string;
  activeButton = false;
  isDone = false;
  showLoading = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userApiService: UserApiService,
    private textHelper: TextHelper,
    private snackBarService: SnackBarService,
    private authAnalytics: AuthenticationAnalyticsService,
    private routeAnimationShared: RouteAnimationShared,
    private webengage: WebengageService
  ) {
    this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');

    this.phoneNumber = this.route.snapshot.paramMap.get('phoneNumber');
  }

  ngOnInit() {
    this.authAnalytics.analyticAuthenticationCodeVisited();
    const time = (this.counter + 1) * 1000;
    const timer$ = timer(time);
    setTimeout(() => {
      if (document.getElementById('input0')) {
        document.getElementById('input0').focus();
      }
    }, 100);
    interval(1000)
      .pipe(takeUntil(timer$))
      .subscribe((x) => {
        this.counter--;
      });
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {}
  onFocus() {
    this.isFocuse = true;
    this.hasError = false;
  }
  onBlur() {
    this.isFocuse = false;
  }
  onLogin() {
    if (this.activationCode.length >= 4) {
      this.activeButton = true;

      this.checkCode();
    }
  }
  clearInput() {
    this.activationCode = '';
  }
  checkCode() {
    let code = this.activationCode;
    code = this.textHelper.replacePersian(code);
    const phoneNumber = this.textHelper.replacePersian(this.phoneNumber);
    this.showLoading = true;
    this.userApiService.login(phoneNumber, code).then((res) => {
      if (res.isSuccess()) {
        this.authAnalytics.analyticAuthenticationVerifyCompleted();
        this.webengage.userCodeLogin();
        this.isDone = true;
        setTimeout(() => {
          if (res.getData().getType() === 'login') {
            this.routeAnimationShared.showRouteAnimation();
            const url = this.textHelper.replaceDeeplinkToCorrectUrls(
              this.returnUrl
            );
            if (url) {
              this.router.navigate([url]);
            } else {
              this.router.navigate([mainUrl], { replaceUrl: true });
            }
            if (!localStorage.getItem('no-need-intro')) {
              localStorage.setItem('no-need-intro', '1');
            }
          } else if (res.getData().getType() === 'register') {
            this.routeAnimationShared.showRouteAnimation();
            if (this.returnUrl) {
              this.router.navigate([registerUrl + '/' + this.phoneNumber], {
                queryParams: { returnUrl: this.returnUrl },
              });
            } else {
              this.router.navigate([registerUrl + '/' + this.phoneNumber]);
            }
          }
          this.showLoading = false;
        }, 850);
      } else {
        this.hasError = true;
        this.errorMessage = res.getData().getMessage();
        this.showLoading = false;
      }
    });
  }

  array(n: number): any[] {
    return Array(n);
  }

  backToPhoneNumberPage() {
    this.routeAnimationShared.showRouteAnimation();
    this.router.navigate([phoneNumberUrl + '/' + this.phoneNumber]);
  }
  activate() {
    if (this.activationCode.length >= 4) {
      this.activeButton = true;
      this.checkCode();
    }
  }
  retrySMS() {
    this.showLoading = true;
    const phoneNumber = this.textHelper.replacePersian(this.phoneNumber);
    this.userApiService.sendSMS(phoneNumber).then((res) => {
      if (res.isSuccess()) {
        this.isDone = true;
        setTimeout(() => {
          this.counter = 60;
          const time = (this.counter + 1) * 1000;
          const timer$ = timer(time);
          interval(1000)
            .pipe(takeUntil(timer$))
            .subscribe((x) => {
              this.counter--;
            });
          this.showLoading = false;
        }, 850);
      } else {
        if (res.getData() && res.getData().getMessage()) {
          this.snackBarService.showSnackBar(res.getData().getMessage());
          this.counter = 60;
          const time = (this.counter + 1) * 1000;
          const timer$ = timer(time);
          interval(1000)
            .pipe(takeUntil(timer$))
            .subscribe((x) => {
              this.counter--;
            });
        } else {
          this.hasError = true;
          this.errorMessage = res.getData().getMessage();
        }
        this.showLoading = false;
      }
    });
  }
}
